import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message, MessageBox } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import {
  completeInitialNavigation,
  isGrowthAdmin,
  getOriginalGrowthLocation,
  getRestrictedGroupLabel,
} from '@/utils/growthAccess'

import { createRouterErrorHandler, getSessionStorage } from '@/utils/chunkReload'

// 每次前端部署都会换掉带 hash 的 js/css。已经打开着的老会话此时第一次进入某个
// 懒加载路由，就会去请求一个服务器上已经不存在的 chunk —— 导航失败、页面白屏，
// 只能手动刷新。这里让它自己刷一次换到新版本。
//
// 防循环两道锁（都落在 sessionStorage）：同一个失败资源 URL 一辈子只刷一次，
// 且每个标签页刷新次数有硬上限。第二次还是同一个资源挂，说明不是「版本换了」而是
// 资源真的取不到，只弹提示绝不再刷；换了新 hash 的资源才允许再刷一次，所以标签页
// 开着跨过第二次发布仍然能自愈。线上资源要是持续挂，无限刷新比白屏更糟。
router.onError(createRouterErrorHandler({
  storage: getSessionStorage(),
  reload: function () { window.location.reload() },
  notify: function () {
    MessageBox.alert(
      '后台刚发布了新版本，当前页面用的资源已经失效。自动刷新之后仍然没有恢复，请手动刷新页面后重试；如果反复出现，请联系管理员。',
      '页面需要刷新',
      { confirmButtonText: '知道了', type: 'warning' }
    ).catch(function () { /* 关掉弹窗会 reject，吞掉即可 */ })
  },
  done: function () { NProgress.done() },
  log: function (error) { console.error(error) },
}))

const whiteList = ['/login', '/m/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  // 手机端英文页不依赖动态菜单，跳过 GenerateRoutes
  if (to.path.indexOf('/m/') === 0) {
    if (to.path === '/m/login' && getToken()) {
      next({ path: '/m/upload' })
    } else if (to.path !== '/m/login' && !getToken()) {
      next({ path: '/m/login' })
    } else {
      next()
    }
    NProgress.done()
    return
  }
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let menus=res.data.menus;
          let username=res.data.username;
          let roles=res.data.roles;
          store.dispatch('GenerateRoutes', { menus,username,roles }).then((accessedRouters) => { // 生成可访问的路由表
            const navigation = completeInitialNavigation(
              accessedRouters,
              route => router.addRoute(route),
              to,
              roles
            )
            if (navigation.denied) {
              Message.warning('仅超级管理员可以访问' + (navigation.deniedLabel || '该模块'))
            }
            next(navigation.target)
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        const restrictedLocation = getOriginalGrowthLocation(to)
        if (restrictedLocation && !isGrowthAdmin(store.getters.roles)) {
          Message.warning('仅超级管理员可以访问' + getRestrictedGroupLabel(restrictedLocation.path))
          next({ path: '/home', replace: true })
          return
        }
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
